/* eslint-disable indent,import/prefer-default-export,no-restricted-globals,space-infix-ops */
import fr from 'facet-rest';

const hiddenFieldNamesProperty = [
  'type',
  'vehicleMake',
  'vehicleModel',
  'vehicleYear',
  'isInsured',
  'isAppraised',
];
const PropertyOverride = fr.metaOverride()
  .nameOverride(name => hiddenFieldNamesProperty.includes(name), { hidden: true })
  .nameOverride('subType', { hidden: false, ordinal: 0, prompt: 'Property Type' })
  .nameOverride('name', { hidden: false, ordinal: 1, prompt: 'Property Name' })
  .nameOverride('ownerClientId', { hidden: false, ordinal: 2 })
  .nameOverride('ownerNotes', { hidden: false, ordinal: 3 })
  .nameOverride('value', { hidden: false, ordinal: 4, prompt: 'Estimated Market Value' })
  .nameOverride('purchasePrice', { hidden: false, ordinal: 5 })
  .nameOverride('purchaseYear', { hidden: false, ordinal: 6 })
  .nameOverride('capitalImprovement', { hidden: false, ordinal: 7 })
  .nameOverride('state', { hidden: false, ordinal: 8, prompt: 'What state is this property located in?' })
  .nameOverride('notes', {
 hidden: false, ordinal: 9, prompt: 'Notes', rows: 5, multiline: true,
});


const hiddenFieldNamesPersonalAsset = [
  'type',
  'vehicleMake',
  'vehicleModel',
  'vehicleYear',
  'capitalImprovement',
  'purchaseYear',
  'purchasePrice',
  'state',
];
const PersonalAssetOverride = fr.metaOverride()
.nameOverride(name => hiddenFieldNamesPersonalAsset.includes(name), { hidden: true })
.nameOverride('name', { hidden: false, ordinal: 0, prompt: 'Asset Name' })
.nameOverride('subType', { hidden: false, ordinal: 1, prompt: 'Asset Type' })
.nameOverride('ownerClientId', { hidden: false, ordinal: 2 })
.nameOverride('ownerNotes', { hidden: false, ordinal: 3 })
.nameOverride('value', { hidden: false, ordinal: 4, prompt: 'Estimated Value' })
.nameOverride('notes', { hidden: false, ordinal: 5 })
.nameOverride('isInsured', { hidden: false, ordinal: 6 })
.nameOverride('isAppraised', { hidden: false, ordinal: 7 });


const hiddenFieldNamesVehicle = [
  'type',
  'capitalImprovement',
  'purchaseYear',
  'purchasePrice',
  'state',
  'ownerClientId',
  'subType',
  'isInsured',
  'isAppraised',
  'name',
];
const VehicleOverride = fr.metaOverride()
.nameOverride(name => hiddenFieldNamesVehicle.includes(name), { hidden: true })
.nameOverride('ownerClientId', { hidden: false, ordinal: 1 })
.nameOverride('ownerNotes', { hidden: false, ordinal: 1 })
.nameOverride('vehicleMake', { hidden: false, ordinal: 2 })
.nameOverride('vehicleModel', { hidden: false, ordinal: 3 })
.nameOverride('vehicleYear', { hidden: false, ordinal: 4 })
.nameOverride('notes', { hidden: false, ordinal: 5, prompt: 'Plans for vehicle' })
.nameOverride('value', { hidden: false, ordinal: 6, prompt: 'Value of vehicle' });


const hiddenFieldNamesBusinessOwnership = [
  'type',
  'capitalImprovement',
  'purchaseYear',
  'purchasePrice',
  'state',
  'isInsured',
  'isAppraised',
  'vehicleMake',
  'vehicleModel',
  'vehicleYear',
];
const BusinessOwnershipOverride = fr.metaOverride()
.nameOverride(name => hiddenFieldNamesBusinessOwnership.includes(name), { hidden: true })
.nameOverride('subType', { hidden: false, ordinal: 0, prompt: 'Business Type' })
.nameOverride('ownerClientId', { hidden: false, ordinal: 1 })
.nameOverride('ownerNotes', { hidden: false, ordinal: 2 })
.nameOverride('name', { hidden: false, ordinal: 3, prompt: 'Business Name' })
.nameOverride('value', { hidden: false, ordinal: 5, prompt: 'Estimated Value' })
.nameOverride('notes', { hidden: false, ordinal: 6, prompt: 'Tell us about the business' });


const hiddenFieldNamesNew = [
  'capitalImprovement',
  'purchaseYear',
  'purchasePrice',
  'state',
  'isInsured',
  'isAppraised',
  'vehicleMake',
  'vehicleModel',
  'vehicleYear',
  'ownerNotes',
  'name',
  'notes',
];
const NewRealAssetOverride = fr.metaOverride()
.nameOverride(name => hiddenFieldNamesNew.includes(name), { hidden: true })
.nameOverride('type', { hidden: false, ordinal: 0, prompt: 'Type' })
.nameOverride('subType', { hidden: false, ordinal: 1, prompt: 'SubType' })
.nameOverride('ownerClientId', { hidden: false, ordinal: 2 })
.nameOverride('value', { hidden: false, ordinal: 3, prompt: 'Estimated Value' });

export {
 PropertyOverride, PersonalAssetOverride, VehicleOverride, BusinessOwnershipOverride, NewRealAssetOverride,
};
